/* eslint-disable dot-notation */
import Vue from 'vue';
import axios from 'axios';
import Vuetify from 'vuetify';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEuroSign,
  faTrash,
  faCheckCircle,
  faBars
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faEuroSign, faTrash, faCheckCircle, faBars);
Vue.component('font-awesome-icon', FontAwesomeIcon);

import { store } from './_store';
import { router } from './_helpers';

import App from './app/App';

import 'vuetify/dist/vuetify.min.css';
import './style.css';
import moment from 'moment';

import VueGoogleCharts from 'vue-google-charts';

Vue.config.productionTip = false;

Vue.use(VueGoogleCharts);

Vue.prototype.$http = axios;
Vue.use(Vuetify);

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY');
  }
});

Vue.filter('valueUnit', function(value) {
  if (value['value']) {
    return value['value'] + ' ' + value['unit'];
  } else {
    return '';
  }
});

Vue.filter('medicine', function(med) {
  if (med['name'] && med['dosis']['value'] && med['dailyAmount']) {
    return (
      med['name'] +
      ': ' +
      med['dosis']['value'] +
      ' ' +
      med['dosis']['unit'] +
      ', ' +
      med['dailyAmount'] +
      ' mal täglich'
    );
  } else {
    return '';
  }
});

Vue.filter('germanBoolean', function(value) {
  if (value) {
    return 'Ja';
  } else {
    return 'Nein';
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  store,
  props: {
    source: String
  },
  validator: {
    validates: {
      match: function(v, result) {
        return result;
      }
    }
  },

  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js